import { AdvertisingSlot } from 'react-advertising'

import {
  FiltersAccordion,
  FiltersAccordionOrigin,
} from '@/components/srp/filters/FiltersAccordion/FiltersAccordion'
import {
  FiltersSidebarPanel,
  SkyscraperBottomLeftAdSlotContainer,
  SkyscraperBottomLeftAdSlotContainerWrapper,
  SkyscraperTopLeftAdSlotContainer,
  SkyscraperTopLeftAdSlotContainerWrapper,
} from '@/components/srp/filters/FiltersSidebar/styled'
import { SrpLoading } from '@/components/srp/srp-loading'
import { GPT_COMPONENT_ID } from '@/features/advertisement/constants/adSlots'
import { RemoteParamKeys, useExperiment } from '@/lib/firebase/hooks'

export type FiltersSidebarProps = {
  isMobileForAds?: boolean
  isLoadingFilters?: boolean
  categoryId?: number
}

export const FiltersSidebar = ({ isMobileForAds, isLoadingFilters }: FiltersSidebarProps) => {
  const srpTopRightExperiment = useExperiment(RemoteParamKeys.SRP_BOTTOM_LEFT_AD_UNIT)
  const srpTopRightExperimentGroup = srpTopRightExperiment?.group

  return (
    <div>
      <FiltersSidebarPanel data-testid="srp-desktop-filter">
        {isLoadingFilters ? (
          <SrpLoading variant={'sidebar-filter-simplified'} />
        ) : (
          <FiltersAccordion isSimplified origin={FiltersAccordionOrigin.SIDE_PANEL} />
        )}
      </FiltersSidebarPanel>

      {!isMobileForAds && (
        <>
          <SkyscraperTopLeftAdSlotContainerWrapper>
            <SkyscraperTopLeftAdSlotContainer>
              <AdvertisingSlot
                id={GPT_COMPONENT_ID.SKYSCRAPER}
                data-testid={GPT_COMPONENT_ID.SKYSCRAPER}
              />
            </SkyscraperTopLeftAdSlotContainer>
          </SkyscraperTopLeftAdSlotContainerWrapper>
          {srpTopRightExperimentGroup === 1 && (
            <SkyscraperBottomLeftAdSlotContainerWrapper>
              <SkyscraperBottomLeftAdSlotContainer>
                <AdvertisingSlot
                  id={GPT_COMPONENT_ID.SKYSCRAPER_LOWER_LEFT}
                  data-testid={GPT_COMPONENT_ID.SKYSCRAPER_LOWER_LEFT}
                />
              </SkyscraperBottomLeftAdSlotContainer>
            </SkyscraperBottomLeftAdSlotContainerWrapper>
          )}
        </>
      )}
    </div>
  )
}
